import Footer from '../Footer';

type SchedulingFlowLayoutProps = {
  children: React.ReactNode;
  navigation: React.ReactNode;
  nextButton?: React.ReactNode;
  precontent?: React.ReactNode;
}

const SchedulingFlowLayout: React.FC<SchedulingFlowLayoutProps> = ({
  children,
  navigation,
  nextButton,
  precontent,
}) => {
  return (
    <div
      className="flex flex-col justify-between min-h-screen"
    >
      {navigation}
      <div
        className="flex flex-col items-center"
      >
        {precontent}
        <div
          className="grid pb-16 pt-4 sm:px-4 lg:px-48 items-start w-full md:grid-cols-6 gap-y-8"
        >
          {children}
        </div>
        {nextButton}
      </div>
      <Footer />
    </div>
  );
};

export default SchedulingFlowLayout;
